import type {PageProps} from "keycloakify/login/pages/PageProps";
import type {KcContext} from "../kcContext";
import type {I18n} from "../i18n";
import {Button, Form} from "react-bootstrap";
import {useContext} from "react";
import InfinigateContext from "../infinigateContext";

export default function LogoutConfirm(props: PageProps<Extract<KcContext, { pageId: "logout-confirm.ftl" }>, I18n>) {
    const {kcContext, i18n, doUseDefaultCss, Template, classes} = props;

    const {redirectTo} = useContext(InfinigateContext);

    const {url, client, logoutConfirm} = kcContext;

    const {msg, msgStr} = i18n;

    return (
        <Template {...{kcContext, i18n, doUseDefaultCss, classes}} displayMessage={false}
                  headerNode={msg("logoutConfirmTitle")}>
            <div id="kc-logout-confirm" className="content-area">
                <p className="instruction">{msg("logoutConfirmHeader")}</p>
                <Form action={url.logoutConfirmAction} method="POST">
                    <input type="hidden" name="session_code" value={logoutConfirm.code}/>
                    <Form.Group>
                        <Button
                            tabIndex={4}
                            variant="outline-primary"
                            name="confirmLogout"
                            id="kc-logout"
                            type="submit"
                        >{msgStr("doLogout")}</Button>
                    </Form.Group>
                </Form>
                <div className="pt-3">
                    {!logoutConfirm.skipLink && client.baseUrl && (
                        <p>
                            <a href={redirectTo ? "https://"+(new URL(redirectTo)).hostname : undefined} dangerouslySetInnerHTML={{__html: msgStr("backToApplication")}}/>
                        </p>
                    )}
                </div>
            </div>
        </Template>
    );
}
